import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useGoTo } from "@/lib/useGoTo";

export const MobileCta = () => {
  const [show, setShow] = useState(false);
  const goTo = useGoTo();
  useEffect(() => {
    const onScroll = () => {
      const b = document.getElementById("termin")?.getBoundingClientRect();
      const inBooking = b ? b.top < window.innerHeight && b.bottom > 0 : false;
      const k = document.getElementById("kontakt")?.getBoundingClientRect();
      const pastBooking = k ? k.top < window.innerHeight : false;
      setShow(window.scrollY > window.innerHeight * 0.7 && !inBooking && !pastBooking);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          className="fixed inset-x-4 bottom-4 z-40 lg:hidden"
        >
          <button
            data-testid="mobile-sticky-booking-btn"
            onClick={() => goTo("termin")}
            className="btn-gold w-full rounded-full py-4 text-[12px] font-semibold uppercase tracking-[0.24em] shadow-[0_14px_40px_rgba(45,36,30,0.25)]"
          >
            Termin anfragen
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
